<template>
  <div class="Apply-Button">
    <span class="T">{{applyButton.name}}</span>
    <!-- 初始状态 （供应商信息还都未保存） 按钮形式 -->
    <div v-if="buttonShowType == 0" class="Initial-State">
      <div v-for="(item,index) in applyButton.buttonResults" :key="index">
        <el-button v-if="item['isShow']" style="width: 170px;margin-right:5px" type="primary" @click="_dataConformity(item)">
          {{item['name']}}
        </el-button>
      </div>
    </div>

    <!-- 初始状态 （供应商信息还都未保存） a标签形式 -->
    <div v-if="buttonShowType == 1" class="Initial-State Initial-a">
      <div class="Initial-a" v-for="(item,index) in applyButton.buttonResults" :key="index">
        <a v-if="item['isShow']" style="width: 170px;" type="primary" @click="_dataConformity(item)">{{item['name']}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import Api from '@/components/Api/index'
  export default {
    name: '',
    components: {},
    props: {
      //buttonShowType 0 是按钮形式 1 是a标签
      buttonShowType: {
        type: Number,
        default: 0
      },
      applyButton: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    // 定义属性
    data() {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      _dataConformity(item) {
        if (this.applyButton.status == 1) {
          this.$message.warning("您的申请正在审批中,请耐心等待...")
        } else if (item.status == -1) {
          this.$emit('maskShow')
          this.$confirm('调整后需要重新发起审核才能生效, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.applyButton.buttonResults.forEach(item => item.isShow = true)
            item.isShow = false
          })
        } else {
          //先做保存,然后再修改状态 这里产生回调
          this.$emit('saveData', {
            applyCallback: (pid) => {
              return new Promise((resolve, rej) => {
                if (pid === '') {
                  this.$message.error('审批发起失败,错误理由：业务审批ID未找到！！！')
                }
                else {
                  //调用业务审批状态修改接口
                  new Api("apply").updateStatusByPid(pid, item.status).then(res => {
                    if (res.status == 200) {
                      //刷新token 
                      new Api("oauth").updateToken(this.$store.state.refreshToken).then((res) => {
                        if (res.status == 200) {
                          this.$store.state.switch = false
                          this.$store.commit("setAccessToken", res.data.accessToken);
                          this.$store.commit("setRefreshToken", res.data.refreshToken);
                          localStorage.setItem(
                            "tokenTime",
                            JSON.stringify(res.data.exp * 1000 + Date.now())
                          );
                        } else {
                          this.Message({
                            type: "error",
                            message: res.statusText,
                          });
                        }
                      });
                      if (item.status == 0) {
                        this.$message.success('保存成功')
                      } else {
                        resolve(1)
                        this.$message.success('审批发起成功')
                      }
                      this.$emit('refreshButton')
                    }
                  })
                }
              })
            }
          })
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  .Apply-Button {
    .T {
      font-size: 16px;
      font-weight: 700;
      color: green;
      margin-right: 30px;
      display: flex;
      align-items: center;
    }

    position: relative;
    z-index: 1009;
    display: flex;
    justify-content: center;

  }

  .Initial-State {
    text-align: center;
    display: flex;
  }

  .Initial-a {
    >a {
      font-size: 12px;
      margin-right: 4px;
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>